import clsx from "clsx";

/** Restaurant logo, or the first letter of its name. Decorative: the name always sits next to it. */
export const Logo = ({
  url,
  name,
  className,
}: {
  url?: string | null;
  name: string;
  className?: string;
}) =>
  url ? (
    <img
      src={url}
      alt=""
      className={clsx("shrink-0 rounded-lg bg-sunken object-cover", className)}
    />
  ) : (
    <span
      className={clsx(
        "flex shrink-0 items-center justify-center rounded-lg bg-sunken font-semibold uppercase text-muted",
        className,
      )}
      aria-hidden="true"
    >
      {[...name.trim()][0] ?? "?"}
    </span>
  );
